module.exports = __webpack_public_path__ + "static/media/teeth-open.8c4b0262.svg";